"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const common_1 = require("../common");
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const createCodeMirror_1 = __importDefault(require("./createCodeMirror"));
const globalCodeMirrorStyles_1 = __importDefault(require("../PrettyText/EditablePrettyText/globalCodeMirrorStyles"));
const codemirror_1 = __importDefault(require("../../styles/codemirror"));
const codemirror_overrides_1 = __importDefault(require("../../styles/codemirror-overrides"));
const FieldFocusContext_1 = require("../FieldFocusContext");
const Styles = common_utils_1.labelStyles(__filename, {
    psuedoInput: common_utils_1.withModifier('custom-code-styles', {
        height: 'auto',
        lineHeight: '25px',
        minHeight: '90px',
        fontFamily: "'Consolas', 'Liberation Mono', Courier, monospace",
        fontWeight: 'normal',
    }),
});
const Code = (props) => {
    const textBoxRef = react_1.useRef(null);
    const valueRef = react_1.useRef(props.value);
    const onChangeCallback = react_1.useCallback(props.onChange, []);
    react_1.useLayoutEffect(() => {
        const codeMirrorConstructor = require('codemirror');
        require('codemirror/addon/display/placeholder');
        require('codemirror/mode/javascript/javascript');
        require('codemirror/mode/python/python');
        const codeMirror = createCodeMirror_1.default({
            codeMirrorConstructor,
            language: props.language,
            node: textBoxRef.current,
            placeholder: props.placeholder,
            value: valueRef.current || '',
        });
        codeMirror.on('change', () => {
            onChangeCallback(codeMirror.getValue());
        });
    }, [onChangeCallback, props.language, props.placeholder]);
    const classNames = [
        'FieldsFormCodeMirror',
        {
            'FieldsFormCodeMirror--errored': props.isErrored,
            'FieldsFormCodeMirror--multiline': true,
        },
    ];
    return (common_utils_1.isolateComponent(FieldFocusContext_1.ExclusiveFieldFocus, null,
        common_utils_1.isolateComponent(common_1.Input, { isErrored: props.isErrored }, (inputProps) => (common_utils_1.isolateComponent("div", { "aria-label": "edit field", css: [inputProps.css, Styles.psuedoInput], id: props.id, key: "psuedoInput", onBlur: props.onBlur, role: "presentation" },
            common_utils_1.isolateComponent(core_1.Global, { styles: codemirror_1.default }),
            common_utils_1.isolateComponent(core_1.Global, { styles: codemirror_overrides_1.default }),
            common_utils_1.isolateComponent(core_1.Global, { styles: globalCodeMirrorStyles_1.default }),
            common_utils_1.isolateComponent(core_1.ClassNames, null, ({ cx }) => (common_utils_1.isolateComponent("div", { className: cx(classNames), ref: textBoxRef }))))))));
};
Code.defaultProps = {
    value: '',
};
exports.default = Code;
